import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import EmojiPicker from "../components/EmojiPicker";
import { AVATARS } from "../lib/constants";
import { toast } from "sonner";

export default function ProfileSetup() {
  const { user, updateProfile } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(user?.name || "");
  const [avatar, setAvatar] = useState(user?.avatar_emoji && AVATARS.includes(user.avatar_emoji) ? user.avatar_emoji : AVATARS[0]);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    const res = await updateProfile(name.trim(), avatar);
    setBusy(false);
    if (res.ok) {
      toast.success("Profile saved!");
      nav("/", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa] w-full flex flex-col">
      <div className="h-32" style={{ background: "linear-gradient(135deg, #1864ab 0%, #1971c2 100%)" }}>
        <div className="max-w-[480px] mx-auto h-full px-6 flex items-end pb-4">
          <div>
            <div className="text-3xl">🎉</div>
            <h1 className="font-display font-black text-white text-2xl leading-tight">Set up your profile</h1>
          </div>
        </div>
      </div>

      <div className="flex-1 max-w-[480px] w-full mx-auto px-6 pt-6 pb-12">
        <p className="text-sm text-[#6c757d] mb-6">
          Pick how you'll appear on the leaderboard. You can change this later.
        </p>

        <form onSubmit={submit} className="space-y-6" data-testid="profile-setup-form">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-[#6c757d] mb-2">
              Display name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="e.g. Jamie R"
              className="w-full bg-white border-2 border-[#e9ecef] rounded-xl px-4 py-3 focus:outline-none focus:border-[#1971c2] focus:ring-2 focus:ring-[#1971c2]/20 font-medium text-base transition-colors"
              data-testid="profile-name-input"
            />
          </div>

          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-[#6c757d] mb-3">
              Avatar
            </label>
            <EmojiPicker value={avatar} onChange={setAvatar} testIdPrefix="profile-avatar" />
          </div>

          <div className="bg-white border border-[#e9ecef] rounded-2xl p-4 flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-[#f8f9fa] border border-[#e9ecef] flex items-center justify-center text-4xl">
              {avatar}
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-wider text-[#6c757d]">Preview</div>
              <div className="font-display font-extrabold text-xl text-[#212529]">{name || "Your name"}</div>
            </div>
          </div>

          <button
            type="submit"
            disabled={busy || !name.trim()}
            className="w-full bg-[#1971c2] hover:bg-[#1864ab] text-white font-display font-extrabold text-base rounded-xl py-3.5 active:scale-95 transition-transform shadow-md disabled:opacity-60"
            data-testid="profile-submit-button"
          >
            {busy ? "Saving…" : "Save & enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
